<template>
  <div>
    <CustomPageHeaderVue>{{
      $t("search_compaign_pagetitle")
    }}</CustomPageHeaderVue>

    <CustomRow>
      <CustomCard class="px-3 py-4 px-md-5 py-md-6 ">
        <v-text-field
          class="search-input"
          v-model="keyword"
          :label="$t('search_compaign_label')"
          outlined
          color="primary-1"
          hide-details
          @click:append="doSearch"
          @keyup.enter="doSearch"
          large
          clearable
        >
          <template v-slot:append>
            <v-icon class="cursor-pointer" @click="doSearch" color="primary-1"
              >mdi-magnify</v-icon
            >
          </template>
        </v-text-field>
        <div class="tab-content text-left ">
          <h4
            class="mt-6"
            v-html="
              $t('search_compaign_result_length', { no: campaigns.length })
            "
          ></h4>
          <template v-if="campaigns.length">
            <ListActivity :campaigns="campaigns" />
          </template>
        </div>
      </CustomCard>
    </CustomRow>
  </div>
</template>

<script>
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";
import ListActivity from "@/views/components/ListActivity.vue";
import { mapGetters, mapActions } from "vuex";
import { getMainEvents } from "@/api/static";

export default {
  components: { ListActivity, CustomPageHeaderVue },
  data() {
    return {
      campaigns: [],
      allEventMainPageInfo: null,
      keyword: this.$route.params.keyword || ""
    };
  },
  computed: {
    ...mapGetters({
      allEvents: "event/allEvents"
    })
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      setAllEvent: "event/setAllEvent"
    }),
    async getMainEvents() {
      const { data } = await getMainEvents();
      this.allEventMainPageInfo = data.allEventMainPageInfo;
      this.setAllEvent(data.allEventMainPageInfo);
      this.doSearch();
    },
    doSearch() {
      let result = [];
      for (var id in this.allEventMainPageInfo) {
        const evt = this.allEventMainPageInfo[id];
        if (evt.title.toLowerCase().includes(this.keyword.toLowerCase()))
          result.push({
            ...evt,
            event_id: id
          });
      }

      if (!result.length) {
        this.showDialog({
          title: this.$t("no_match_compaign_title"),
          content: this.$t("no_match_compaign_desp"),
          buttons: [
            {
              text: this.$t("got_it"),
              action: () => {}
            }
          ]
        });

        return;
      }

      this.campaigns = result;
    }
  },
  beforeMount() {
    if (!this.allEvents || Object.keys(this.allEvents).length === 0) {
      this.getMainEvents();
    } else this.allEventMainPageInfo = this.allEvents;
  }
};
</script>

<style lang="scss" module>
.search-input {
  border-radius: 4px !important;
}

::v-deep {
  .v-card > *:first-child:not(.v-btn):not(.v-chip):not(.v-avatar),
  .v-card > .v-card__progress + *:not(.v-btn):not(.v-chip):not(.v-avatar),
  .v-card > .v-card__progress + :not(.v-btn):not(.v-chip):not(.v-avatar),
  .v-card > :first-child:not(.v-btn):not(.v-chip):not(.v-avatar) {
    border-radius: 4px !important;
  }
}
</style>
